import {makeStyles} from "@material-ui/core/styles";
import {format, parseISO} from "date-fns";
import ru from "date-fns/locale/ru";
import React, {useContext, useEffect} from "react";
import Typography from "@material-ui/core/Typography";
import {getRequestMessages} from "../../../../../Dialog/store/actions";
import SecurityContext from "../../../../../SecurityContext";
import {connect} from "react-redux";
import MessageInbox from "../../../../../Dialog/components/MessageInbox";
import MessageOutbox from "../../../../../Dialog/components/MessageOutbox";
import TextField from "../../../../../ui/TextField";
import Button from "../../../../../ui/Button";
import {createRequestMessage} from "../../../../../Dialog/store/send";
import Progress from "../../../../../ui/Progress";

const useStyles = makeStyles(() => ({
  root: {
    paddingLeft: 8,
    width: 774
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  dialogView: {
    overflowY: "auto",
    maxHeight: "445px",
    padding: "40px 50px",
    border: "1px solid #e9ecf7",
    borderTop: "none"
  },
  dialogDay: {
    display: "block",
    "& p": {
      marginBottom: "18px",
      textAlign: "center",
      color: "#789",
      fontSize: "16px",
      fontWeight: 500
    }
  },
  dialogTextField: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "68px",
    padding: "0 16px",
    border: "1px solid #e9ecf7",
    borderTop: "none",
    "& .MuiInputBase-root" : {
      width: "80%",
      height: "100%",
      color: "#789",
      border: "none",
      fontSize: "16px",
      fontWeight: 500
    }
  }
}));

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const Dialog = ({requestId,
                  getRequestMessages,
                  createRequestMessage,
                  messageList,
                  isFetchingMessages,
                  isCreatingMessage}) => {
  const [newMessage, setNewMessage] = React.useState("");
  const [groupMessages, SetGroupMessages] = React.useState(null);

  const classes = useStyles();
  let securityContext = useContext(SecurityContext);
  const { token } = securityContext.keycloak;

  useEffect(() => {
    if (requestId) {
      getRequestMessages(requestId, token);
    }
  }, [requestId]);

  useEffect(() => {
    if (messageList) {
      const groupMsg = messageList.reduce((acc, x) => {
        const [date] = x.dateSend.split("T");
        let group = acc[date];
        if (!group) {
          acc[date] = group = { date, msg: [] };
        }
        group.msg.push(x);
        return acc;
      }, {});

      SetGroupMessages(Object.values(groupMsg));
    }
  }, [messageList]);

  const sendMessage = () => {
    if (newMessage != null && newMessage != "") {
      const data = {
        content: newMessage
      };
      createRequestMessage(requestId, token, data);
    }
  };

  return (
    <div className={classes.root}>
      <Typography className={classes.heading}>История сообщений</Typography>
      <div className={classes.dialogView}>

        {groupMessages && groupMessages.map((item, index) =>
          <div key={index} className={classes.dialogDay}>
            <p>{format(parseISO(item.date), "dd.MM.yyyy")}</p>
            {item.msg.map((msg, index) =>
              msg.inbox
                ? <MessageInbox key={index} content={msg.content} personAvatar={msg.senderAvatar}/>
                : <MessageOutbox key={index} content={msg.content} personAvatar={msg.senderAvatar}/>
            )}
          </div>
        )}
      </div>
      <div className={classes.dialogTextField}>
        <TextField
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
        />
        <Button
          onClick={sendMessage}
          loading={isFetchingMessages || isCreatingMessage}
          color="green"
        >
          ОТПРАВИТЬ
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  messageList: state.dialog.messageList,
  isFetchingMessages: state.dialog.isFetchingMessages,
  isCreatingMessage: state.dialog.isCreatingMessage
});

const mapDispatchToProps = dispatch => ({
  getRequestMessages: (requestId, token) => dispatch(getRequestMessages(requestId, token)),
  createRequestMessage: (requestId, token, data) => dispatch(createRequestMessage(requestId, token, data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dialog);
